import { createClient } from '@sanity/client'

export const client = createClient({
  projectId: 'as71t1e6',
  dataset: 'production',
  apiVersion: '2025-05-01',
  useCdn: true,
})